export function defaultHeaders() {
  return { bankid: sessionStorage.getItem("selectedBank"), Authorization: `Bearer ${sessionStorage.getItem("token")}` };
}
